import React, { useEffect, useState } from "react";
import DropzoneArea from "../Form/File/DropzoneArea";
import { ButtonPrimary, ButtonSpan } from "../Button";
import { WhitePanelWithHeader } from "../../ui";
import { formatDate } from "../../modules/dates";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { token } from "../../modules/auth";
import { storeSingleBookedEventConfirmation } from "../../redux/actions";
import Loading from "../Loading";

let VenueCompletedInformation = ({
  deleteFile,
  event,
  storeSingleBookedEventConfirmation,
  token,
}) => {
  let [invoiceUploadedDocument, setInvoiceUploadedDocument] = useState();
  let [submitting, setSubmitting] = useState(false);
  let uploadContractDocument = file => {
    setInvoiceUploadedDocument(file);
  };

  const _deleteFile = (uploadDocument, loadedDocument) => {
    if (
      typeof uploadDocument !== "undefined" &&
      uploadDocument &&
      uploadDocument.length > 0
    ) {
      setInvoiceUploadedDocument(null);
    } else if (typeof loadedDocument[0] !== "undefined") {
      return deleteFile(loadedDocument[0].id);
    }
  };

  const fetchFileName = uploadDocument => {
    if (
      uploadDocument &&
      typeof uploadDocument !== "undefined" &&
      typeof uploadDocument[0] !== "undefined"
    ) {
      return uploadDocument[0].name;
    }

    return null;
  };

  const uploadFileInvoiceFile = () => {
    setSubmitting(true);
    const formData = new FormData();
    if (invoiceUploadedDocument) {
      formData.append("invoice_document", invoiceUploadedDocument[0]);
    }
    return storeSingleBookedEventConfirmation(event.id, token, formData).then(
      response => {
        setSubmitting(false);
        window.location.reload();
      }
    );
  };
  return (
    <WhitePanelWithHeader
      title={"Completed Event Information"}
      collapsible
      defaultOpen={true}
    >
      <div className={"row  p-3 mb-5 "}>
        <div className="col col-w-1/2 flex  flex-col ">
          <h3 className="mb-2">Final Invoice from Venue to Client</h3>
          <p>
            Upload the final invoice for the client here
          </p>
          {typeof event.invoice_file !== "undefined" &&
          event.invoice_file.length > 0 &&
          event.invoice_uploader &&
          !invoiceUploadedDocument ? (
            <React.Fragment>
              <p>
                Uploaded By:{" "}
                {event.invoice_uploader.first_name +
                  " " +
                  event.invoice_uploader.surname}{" "}
                ({event.invoice_uploader.email})
              </p>
              <p>
                Uploaded At:{" "}
                {formatDate(event.invoice_upload_date, "DD/MM/YYYY hh:mm:ss")}
              </p>
              <a
                className={"font-bold"}
                href={event.invoice_file_url}
                target={"_blank"}
              >
                Download Invoice File
              </a>
            </React.Fragment>
          ) : (
            <p>No documents have been uploaded</p>
          )}

          {invoiceUploadedDocument ? (
            <div className={"flex flex-row"}>
              <p>
                {fetchFileName(invoiceUploadedDocument, event.invoice_file)}
              </p>
              <React.Fragment>
                <ButtonSpan
                  className="pointer text-warning"
                  onClick={() =>
                    _deleteFile(invoiceUploadedDocument, event.invoice_file)
                  }
                >
                  <i className="ml-3 fas fa-trash-alt" />
                </ButtonSpan>
              </React.Fragment>
            </div>
          ) : typeof event.invoice_file !== "undefined" &&
            event.invoice_file.length > 0 &&
            event.invoice_uploader ? null : event.event_status.code <
            30 ? null : (
            <DropzoneArea
              type="document_plus"
              minWidth={"200px"}
              minHeight={"100px"}
              onDrop={uploadContractDocument}
              uploading={false}
            />
          )}
          {typeof event.contract_file === "undefined" ||
          event.invoice_file.length === 0 ? (
            <div>
              <ButtonPrimary
                type="submit"
                small
                onClick={() => uploadFileInvoiceFile()}
              >
                {submitting ? <Loading inline /> : "Save"}
              </ButtonPrimary>
            </div>
          ) : null}
        </div>
      </div>
    </WhitePanelWithHeader>
  );
};

const mapStateToProps = state => ({
  token: token(state),
});

const mapDispatchToProps = {
  storeSingleBookedEventConfirmation,
};

VenueCompletedInformation = reduxForm({
  form: "venueCompletedInformationForm",
  enableReinitialize: true,
})(VenueCompletedInformation);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VenueCompletedInformation);
